// @core/api/endpoints/subscription/create_subscription.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  CreateSubscriptionRequest,
  SubscriptionResponse,
} from '../../../types/subscription';

const BASE_PATH = '/subscription';

/**
 * Create a new subscription
 * Creates a new subscription for a tenant to a specific plan. Handles trial periods, payment setup, and optional discount codes.
 */
export async function CreateSubscription(
  data: CreateSubscriptionRequest,
  options?: RequestOptions
): Promise<SubscriptionResponse> {
  const client = getApiClient();
  const requestPath = `${BASE_PATH}/subscriptions`;
  const requestOptions = options;
  return client.post<SubscriptionResponse>(requestPath, data, requestOptions);
}
